import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { userRoles } from '../../../helpers/constants';
import { enableSpinner, recordTime, TIMESTAMP_LEAVE } from '../../mle/mle-actions';
import { FINISH_SPINNER } from '../footer-qtc.actions';

export const useFinish = () => {
  const dispatch = useDispatch();
  const { userReducer, queryStringReducer } = useSelector(state => state);
  const isTeacher = userReducer.userRole === userRoles.TEACHER || queryStringReducer.isPreview;
  const [hasFinished, setHasFinished] = useState(false);

  const completeCallback = () => {
    if (window.history.length === 1) {
      window.close();
    } else {
      window.history.back();
    }
  };

  const handleFinish = async () => {
    dispatch(enableSpinner(FINISH_SPINNER));
    setHasFinished(true);
    if (!isTeacher) {
      await dispatch(recordTime(TIMESTAMP_LEAVE));
    }
    completeCallback();
  };

  return { handleFinish, hasFinished };
};
